export default {
    AccountBalance: "Balance",
    TurnoverSheet: "Trial balance",
    Transfers: "Report on shipments",
    TransferUnitCount: "Report on cargo units"
};